module.exports = __webpack_public_path__ + "static/assets/835e05a24ee7dafdc658e729d85bf9ab.gif";